import { render, staticRenderFns } from "./LogoNavbarBrand.vue?vue&type=template&id=3b39759e"
import script from "./LogoNavbarBrand.vue?vue&type=script&lang=js"
export * from "./LogoNavbarBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports